var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPicture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.027 0c1.005 0 1.819.835 1.819 1.867s-.814 1.87-1.819 1.87-1.82-.838-1.82-1.87S11.021 0 12.027 0ZM.308 10.214l4.175-6.96c.35-.412 1.142-.412 1.49 0L8.686 7.77l1.074-1.79c.249-.295.811-.295 1.06 0l2.964 4.942c.56.933-.03 2.078-1.021 2.078H1.744C.334 13-.481 11.529.308 10.214Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/picture.521d59dd7f07fc2a2bc4474ce5540b91.svg";